import { render, staticRenderFns } from "./SelectTab.vue?vue&type=template&id=d035a600&scoped=true"
import script from "./SelectTab.vue?vue&type=script&lang=js"
export * from "./SelectTab.vue?vue&type=script&lang=js"
import style0 from "./SelectTab.vue?vue&type=style&index=0&id=d035a600&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d035a600",
  null
  
)

export default component.exports